<template>
  <div>
    <div class="flex gap-2 items-center text-primary text-xl font-medium">
      <v-icon
        color="primary">
        mdi-note-text-outline
      </v-icon>
      <span>ตั้งค่าออเดอร์</span>
    </div>
    <v-card
      class="py-5 px-7 mt-6 rounded-lg"
      flat>
      <p class="text-xl font-medium mb-5">
        สถานะออเดอร์
      </p>
      <order-toggle
        v-model="setting.enableReadyToShipStage"
        :text="$t('order.enableReadyToShipStage')"
        :state="state.enableReadyToShipStage"
        description="ทุกออเดอร์จะมีขั้นตอนยืนยันออเดอร์ขึ้นมาเพื่อให้ร้านค้ากดยืนยันออเดอร์ก่อนที่จะย้ายออเดอร์ไปอยู่ที่สถานะรอพิมพ์"
        @input="submit('enableReadyToShipStage')" />
      <div class="my-7">
        <hr />
      </div>
      <order-toggle
        v-model="setting.enableHolding"
        :text="$t('order.enableHolding')"
        :state="state.enableHolding"
        description="สามารถกดพักออเดอร์เพื่อจัดส่งภายหลัง หรือลูกค้าจะสามารถแจ้งโอนเงินได้หลายครั้ง"
        @input="submit('enableHolding')" />
      <div class="my-7">
        <hr />
      </div>
      <order-toggle
        v-model="setting.changePrint"
        :text="$t('order.changePrint')"
        description="หลังจากการพิมพ์ที่อยู่แล้วมีการแก้ไขออเดอร์ ออเดอร์นั้นจะเปลี่ยนสถานะกลับมาอยู่ที่สถานะ “รอพิมพ์” เพื่อให้พิมพ์ใหม่อีกครั้ง"
        :state="state.changePrint"
        @input="submit('changePrint')" />
    </v-card>
    <v-card
      class="py-5 px-7 mt-6 rounded-lg"
      flat>
      <p class="text-xl font-medium mb-5">
        การยกเลิกออเดอร์
      </p>
      <order-toggle
        v-model="setting.autoCancelMarketplaceOrder"
        :text="$t('order.autoCancelMarketplaceOrder')"
        description="เมื่อออเดอร์ Marketplace ถูกตีกลับ ระบบจะยกเลิกออเดอร์ให้อัตโมมัติ"
        :state="state.autoCancelMarketplaceOrder"
        @input="submit('autoCancelMarketplaceOrder')" />

      <div class="my-7">
        <hr />
      </div>
      <order-toggle
        v-model="setting.autoCancelShipnityExpressOrder"
        :text="$t('order.autoCancelShipnityExpressOrder')"
        :state="state.autoCancelShipnityExpressOrder"
        description=" เมื่อออเดอร์ที่ส่งผ่านระบบ Shipnity Express ถูกตีกลับ ระบบจะยกเลิกออเดอร์ให้อัตโมมัติ"
        @input="submit('autoCancelShipnityExpressOrder')" />
    </v-card>
    <v-card
      class="py-5 px-7 mt-6 rounded-lg"
      flat>
      <p class="text-xl font-medium mb-5">
        การแจ้งโอนเงิน
      </p>
      <order-toggle
        v-model="setting.editProductAfterPay"
        :text="$t('order.editProductAfterPay')"
        :state="state.editProductAfterPay"
        description=" หากลูกค้าทำการแจ้งโอนเงินมา แล้วต้องการแก้ไขสินค้าในออเดอร์นั้นๆ ทางร้านค้าจะสามารถทำการแก้ไขสินค้าในออเดอร์นั้นได้"
        @input="submit('editProductAfterPay')" />
      <div class="my-7">
        <hr />
      </div>
      <order-toggle
        v-model="setting.pendingAllOrders"
        :text="$t('order.pendingAllOrders')"
        :state="state.pendingAllOrders"
        description=" เมื่อแจ้งโอนเงินเรียบร้อยแล้วร้านค้าต้องกดยืนยันการแจ้งโอนเงินแต่ละออเดอร์อีกครั้งเพื่อยืนยันการชำระเงิน"
        @input="submit('pendingAllOrders')" />
    </v-card>
    <v-card
      class="py-5 px-7 mt-6 rounded-lg"
      flat>
      <p class="text-xl font-medium mb-5">
        Facebook Live
      </p>
      <order-toggle
        v-model="setting.liveOrderAutoMerge"
        :text="$t('order.liveOrderAutoMerge')"
        :state="state.liveOrderAutoMerge"
        description="กรณีเป็นออเดอร์ลูกค้าคนเดียวกันจากช่องทาง Facebook Live คนละ Live
        ระบบจะรวมออเดอร์ของลูกค้าเป็นออเดอร์เดียวกันให้อัตโนมัติ หากออเดอร์นั้นยังไม่ชำระเงิน"
        @input="submit('liveOrderAutoMerge')" />
    </v-card>
    <v-card
      class="py-5 px-7 mt-6 rounded-lg"
      flat>
      <p class="text-xl font-medium mb-5">
        ระบบขายหน้าร้าน (POS)
      </p>
      <order-toggle
        v-model="setting.posAutoRedirect"
        :text="$t('order.posAutoRedirect')"
        :state="state.posAutoRedirect"
        description="เมื่อบันทึกออเดอร์ขายหน้าร้าน (POS) แล้วจะไปที่หน้าพิมพ์ใบเสร็จทันที"
        @input="submit('posAutoRedirect')" />
    </v-card>
    <v-card
      class="py-5 px-7 mt-6 rounded-lg flex flex-col sm:flex-row sm:items-center gap-2 justify-between"
      flat>
      <span class="text-xl font-medium">รูปแบบเลขกำกับรายการ</span>
      <order-selection
        v-model="setting.invoiceNumberOption"
        :state="state.invoiceNumberOption"
        :items="invoiceNumberEnum"
        @input="submit('invoiceNumberOption')" />
    </v-card>
    <v-card
      class="py-5 px-7 mt-6 rounded-lg"
      flat>
      <v-form
        ref="form"
        v-model="valid"
        :readonly="loading"
        lazy-validation
        @submit.prevent="submit('preorderLimit')">
        <div class="flex items-center sm:justify-between">
          <div
            class="flex items-center gap-2 text-base sm:text-xl font-medium">
            {{ $t('order.preorderLimit') }}
            <v-text-field
              v-if="edit"
              v-model="setting.preorderLimit"
              style="max-width: 200px;"
              dense
              outlined
              hide-details />
            <span
              v-else
              class="text-primary">
              {{ setting.preorderLimit }}
            </span>
            {{ $t('order.days') }}
          </div>
          <div>
            <save-change-button
              v-if="edit"
              class="mr-1"
              :state="state.preorderLimit"
              :disabled="!valid"
              :label="$t('order.btn.save')"
              @click="submit('preorderLimit')">
            </save-change-button>
            <v-btn
              v-else
              color="primary"
              rounded
              depressed
              @click="openEditOrderAge()">
              <v-icon icon>
                mdi-square-edit-outline
              </v-icon>
              <span>
                {{ $t('order.btn.edit') }}
              </span>
            </v-btn>
          </div>
        </div>
      </v-form>
      <span class="text-order-closed text-sm font-normal">ระยะเวลาออเดอร์สำหรับการแจ้งโอนเงิน</span>
    </v-card>
  </div>
</template>

<script>
import { GET_SETTING_ORDER } from '@/resources/graphql/query/Setting'
import { GET_INVOICENUMBEROPTION_ENUM } from '@/resources/graphql/query/Enum'
import { UPDATE_SETTING } from '@/resources/graphql'
import OrderSelection from './OrderSelection.vue'
import OrderToggle from './OrderToggle.vue'

export default {
  name: 'OrderSetting',
  components: {
    OrderSelection,
    OrderToggle
  },
  apollo: {
    setting: () => ({
      fetchPolicy: 'no-cache',
      query: GET_SETTING_ORDER,
      result () {
        if (this.setting.autoTransferBank) {
          this.createOrder = true
        }
        this.setting.paymentMethods.unshift({
          display_name: 'เลือกธนาคาร',
          value: ''
        })
      }
    }),
    __type: () => ({
      query: GET_INVOICENUMBEROPTION_ENUM,
      result ({ data: { __type } }) {
        this.invoiceNumberEnum = __type.enumValues
      },
      update: (data) => data.__type
    })
  },
  data () {
    return {
      edit: false,
      valid: true,
      invoiceNumberEnum: [],
      createOrder: false,
      setting: {},
      state: {
        createOrder: 'ready',
        autoTransfer: 'ready',
        editProductAfterPay: 'ready',
        enableReadyToShipStage: 'ready',
        enableHolding: 'ready',
        posAutoRedirect: 'ready',
        liveOrderAutoMerge: 'ready',
        changePrint: 'ready',
        pendingAllOrders: 'ready',
        invoiceNumberOption: 'ready',
        preorderLimit: 'ready',
        autoVerifyPayment: 'ready',
        autoVerifyAcceptOverpaid: 'ready',
        autoVerifyAcceptUnderpaid: 'ready',
        autoCancelMarketplaceOrder: 'ready',
        autoCancelShipnityExpressOrder: 'ready'
      }
    }
  },
  computed: {
    loading () {
      return this.state.preorderLimit === 'loading'
    }
  },
  methods: {
    openEditOrderAge () {
      this.edit = true
    },

    async submit (field) {
      this.state[field] = 'loading'
      if (field === 'preorderLimit') {
        this.setting[field] = Number(this.setting[field])
      }
      const res = await this.$apollo.mutate({
        mutation: UPDATE_SETTING,
        variables: {
          input: {
            [field]: this.setting[field]
          }
        }
      }).catch(() => {})
      if (res) {
        const { data: { updateSetting } } = res
        if (updateSetting.errors && Object.keys(updateSetting.errors).length) {
          this.state[field] = 'error'
        } else {
          this.state[field] = 'success'
        }
        if (field === 'preorderLimit') {
          setTimeout(() => {
            this.state.preorderLimit = 'ready'
            this.edit = false
          }, 1000)
        }
      }
    }
  }
}
</script>
